(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1440px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newmenus"] && !Shopify.designMode) return;
  try {
    
class CategoryFocusGrid {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.grid = this.wrapper.querySelector('.category-grid');
    this.subcategoriesContainer = this.wrapper.querySelector('.subcategories-container');
    this.backButton = this.wrapper.querySelector('.focus-view__back-button');
    this.bindEvents();
  }

  showFocusView(clickedLink) {
    this.wrapper.classList.add('is-focused');
    clickedLink.classList.add('is-active');
    this.backButton.style.display = 'inline-block';

    try {
      const subcategoriesData = JSON.parse(clickedLink.dataset.subcategories);
      
      this.subcategoriesContainer.innerHTML = '';
      const subcategoriesList = document.createElement('div');
      subcategoriesList.className = 'subcategories-list';

      if (subcategoriesData.length === 0) {
        subcategoriesList.innerText = 'Keine Unterkategorien gefunden.';
      }

      subcategoriesData.forEach(sub => {
        const link = document.createElement('a');
        link.href = sub.url;
        link.className = 'subcategory-button';

        if (sub.image_url) {
          const img = document.createElement('img');
          img.src = sub.image_url.split('?')[0];
          img.className = 'subcategory-button__image';
          img.loading = 'lazy';
          img.alt = sub.title;
          img.width = 32;
          img.height = 32;
          link.appendChild(img);
        }
        
        const span = document.createElement('span');
        span.textContent = sub.title;
        link.appendChild(span);
        
        subcategoriesList.appendChild(link);
      });
      
      this.subcategoriesContainer.appendChild(subcategoriesList);
    } catch (e) {
      console.error("Fehler beim Verarbeiten der Unterkategorien:", e);
      this.subcategoriesContainer.innerHTML = '<div class="subcategories-list" style="color: red; background: white; padding: 10px;">Fehler beim Laden der Daten.</div>';
    }
  }

  hideFocusView() {
    this.wrapper.classList.remove('is-focused');
    this.backButton.style.display = 'none';
    const activeLink = this.wrapper.querySelector('.main-category__link.is-active');
    if (activeLink) {
      activeLink.classList.remove('is-active');
    }
    this.subcategoriesContainer.innerHTML = '';
  }

  bindEvents() {
    this.grid.addEventListener('click', (event) => {
      const clickedLink = event.target.closest('.main-category__link');
      if (clickedLink) {
        const subCount = parseInt(clickedLink.dataset.subCount, 10) || 0;
        if (subCount > 0) {
          event.preventDefault();
          this.showFocusView(clickedLink);
        }
      }
    });

    this.backButton.addEventListener('click', this.hideFocusView.bind(this));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const categoryGrids = document.querySelectorAll('.category-focus-wrapper');
  categoryGrids.forEach(wrapper => {
    if (!wrapper.dataset.initialized) {
      new CategoryFocusGrid(wrapper);
      wrapper.dataset.initialized = true;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
